export default __webpack_public_path__ + "static/media/093-curved-arrow-1.0719017c.png";